'use client';

import { useInstantSearch } from 'react-instantsearch';

/**
 * Search results wrapper that only renders when there's a search query (v7 version)
 */
const SearchResultsWrapperNext = ({ children }) => {
  const { results } = useInstantSearch();

  if (!results || !results.query) {
    return null;
  }

  return children;
};

export default SearchResultsWrapperNext;
